// toggle g-navi

$(() => {

  const $nav = $('[data-plugin=toggleNav]'),
        $nav_parent = $nav.parent()
  
  $nav.on('click',function(){
    const target = this.dataset.target
    if(target == undefined ) return
    if( $(target).hasClass('open') ){
      $(target).addClass('closing')
      setTimeout(()=> $(target).removeClass('closing') ,500)
    }
    $(target).toggleClass('open')
    $(this).toggleClass('active')
    $('body').toggleClass('navOpen')
    
  });
  
  $nav.dismiss = function() {
    $(this.dataset.target).removeClass('open')
    $(this).removeClass('active')
    $('body').removeClass('navOpen')
  }
  
  $(document).on('click touchend',(e) => {
    if (!$(e.target).closest($nav_parent).length) {
      $nav.dismiss.call($nav[0])
    }
  });
  
})